export default __webpack_public_path__ + "static/media/icon8.0a23eb0e.svg";